<div class="image-view-controls">
  <button
    appButton
    name="DONTREPORT"
    location="image-viewer-controls"
    [iconButton]="true"
    color="simple-gray-50"
    height="0"
    class="minus"
    shape="round"
    (click)="doScale('out', $event)"
    [appTooltip]="'Zoom Out'"
  >
    <app-svg src="/assets/icons/zoom-minus.svg"></app-svg>
  </button>
  <button
    appButton
    name="full"
    location="image-viewer-controls"
    color="simple-gray-50"
    weight="bold"
    height="0"
    spacing="1"
    shape="round"
    class="scale-percent"
    [appTooltip]="scalePercent === 100 ? 'Zoom to Fit' : 'Actual Size'"
    (click)="doScale('full', $event)"
  >
    <span>{{ scalePercent }}</span
    >%
  </button>
  <button
    appButton
    name="DONTREPORT"
    location="image-viewer-controls"
    [iconButton]="true"
    color="simple-gray-50"
    height="0"
    class="plus"
    shape="round"
    (click)="doScale('in', $event)"
    [appTooltip]="'Zoom In'"
  >
    <app-svg src="/assets/icons/zoom-plus.svg"></app-svg>
  </button>
</div>
